import { Cloudinary } from '@cloudinary/url-gen';
import { CLOUDINARY_DAM_CLOUDNAME } from '../utils/constants';

const cloudinaryInstance = new Cloudinary({
  cloud: {
    cloudName: CLOUDINARY_DAM_CLOUDNAME,
  },
});

export default cloudinaryInstance;
